import { SERVICE_URL_TEMPLATE } from '../../lib/config';

const extractUrlDetails = (url: string): {
  appId?: string;
  serviceName?: string;
} => {
  const serviceUrlRegexTemplate = (SERVICE_URL_TEMPLATE as string)
    .replace('{appId}', '([a-zA-Z0-9]*)')
    .replace('{serviceName}', '([a-zA-Z0-9]*)');

  const serviceUrlRegex = new RegExp(serviceUrlRegexTemplate);
  const results = serviceUrlRegex.exec(url);

  if (results) {
    const appId = results[1];
    const serviceName = results[2];
    return {
      appId,
      serviceName,
    };
  }
  return {};
};

export default extractUrlDetails;
